import 'react-toastify/dist/ReactToastify.css';
import { useState, useEffect } from 'react';

import LOYALBUDS from "../media/images/loyalbuds_dark_pro.png";
import { FaAppStore, FaDiscord, FaGooglePlay, FaInstagram, FaTwitter, FaPaperPlane } from "react-icons/fa";
import { ToastContainer } from 'react-toastify';
import BusinessService from '../services/business_services';
import Header from './header';

//TRANSLATION
import { useTranslation } from 'react-i18next';

function Credits() {
    const { t } = useTranslation();
    const [merchant, setMerchant] = useState({});

    const loadMerchant = async () => {
        const data = await BusinessService.business()
        console.log(data);
        setMerchant({
            credits: data.business.credits,
            monthly_credits: data.business.monthly_credits,
            created_date: data.business.created_date,
        })
    }

    useEffect(() => {
        loadMerchant();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="container">
            <Header page={"Credits"} />
            <div className="content simple" style={{ paddingTop: 50 }}>
                <h1 className="title" style={{ marginBottom: 10 }}>
                    Vos crédits
                </h1>
                <p>
                    Chaque scan d'un client sur votre carte de fidélité consomme un crédit.
                </p>
                <div style={{ display: "block", height: 1, backgroundColor: "#555", margin: "20px auto", width: 300 }}>
                </div>
                <h2 style={{ textAlign: "center", fontVariant: "small-caps" }}>
                    <big>{merchant?.credits}</big>
                    <br />
                    crédits restants
                </h2>
                <h4 style={{ textAlign: "center", fontVariant: "small-caps" }} >
                    {merchant?.monthly_credits} crédits mensuels
                    <br />
                    <small>Crédits réinitialisés le {new Date(merchant?.created_date).getDate()} de chaque mois</small>
                </h4>
                <div style={{ display: "block", height: 1, backgroundColor: "#555", margin: "20px auto", width: 300 }}>
                </div>
                <h4 style={{ textAlign: "center" }} >
                    Besoin de plus de crédits ou d'informations ?
                </h4>
                <div className="button d-block" onClick={() => window.open("mailTo:contact@loyalbuds.io")}>
                    <FaPaperPlane /> Nous contacter
                </div>
            </div>
            <footer>
                <img src={LOYALBUDS} className="logo" alt="logo LoyalBuds" />
                <p className="privacy">
                    <a href="/privacy">{t('privacy.policy')}</a> | <a href="/cgu">{t('cgu.general_terms')}</a>
                </p>
                <p className="copyright">
                    {t('home.website')}
                    <br />
                    <strong>Copyright @Codinsight. 2025</strong>
                </p>
                <div className="entry">
                    <p>
                        <strong>Editeur du Site</strong>
                    </p>
                    <p>
                        L'éditeur du Site est Codinsight, société par actions simplifiée au capital de 8000€,
                        immatriculée 907 943 088 au RCS de Montpellier.
                    </p>
                    <p>
                        N° TVA : FR18907943088
                        <br />
                        Email : contact@codinsight.com
                        <br />
                        Directeur de publication : M. Fabien BUCAMP.
                    </p>
                </div>
                <div className="entry">
                    <p>
                        <strong>Hébergeur du Site</strong>
                    </p>
                    <p>
                        Ce site est hébergé exclusivement sur des datacenters en France (Paris) de la société Amazon Web Services
                    </p>
                    <p>
                        Amazon Web Services Inc.
                        <br />
                        410 Terry Avenue North,
                        <br />
                        Seattle, WA 98109-5210, USA
                    </p>
                </div>
                <div className="entry">
                    <div className="link" onClick={() => window.open("https://apps.apple.com/us/app/loyalbuds/id6476626608?platform=iphone")}>
                        <FaAppStore />
                    </div>
                    <div className="link" onClick={() => window.open("https://play.loyalbuds.app")}>
                        <FaGooglePlay />
                    </div>
                    <div className="link" onClick={() => window.open("https://discord.com/invite/sHbvCwhPGz")}>
                        <FaDiscord />
                    </div>
                    <div className="link" onClick={() => window.open("https://twitter.com/LoyalBuds")}>
                        <FaTwitter />
                    </div>
                    <div className="link" onClick={() => window.open("https://www.instagram.com/loyalbudsgame/")}>
                        <FaInstagram />
                    </div>
                </div>
            </footer>
            <ToastContainer />
        </div>
    );
}

export default Credits;
